import { WorkspacePrebidModuleDTO } from 'features/globalSetup/api/types/workspacePrebidModule'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'

export const WORKSPACE_PREBID_MODULE_FRAGMENT: TypedDocumentNode<WorkspacePrebidModuleDTO> = gql`
  fragment WorkspacePrebidModuleFragment on WorkspacePrebidModule {
    id
    enabled
    prebidModule {
      name
      demand
    }
    status
    updatedAt
  }
`
